let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("8SfJg"), load("3UftB")]).then(() => parcelRequire('cW5we'));